<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "CHANGE_EMAIL.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card>
    <mat-card-content>
        <button
            [id]="'button_profile-change-email_EditarSalvar'"
            mat-mini-fab
            color="primary"
            (click)="toggleEdition()"
            class="edition-button"
        >
            <mat-icon aria-label="label">{{ editMode ? "save" : "create" }}</mat-icon>
        </button>

        <div class="alert alert-info">
            <p>
                <strong>{{ "CHANGE_EMAIL.IMPORTANT" | translate }}</strong
                >{{ "CHANGE_EMAIL.SUBTITLE" | translate }}
            </p>
            <p>
                {{ "CHANGE_EMAIL.SUBTITLE2" | translate }}
            </p>
        </div>

        <div class="form-container">
            <mat-form-field>
                <mat-label>
                    {{ "CHANGE_EMAIL.INPUTS.EMAIL" | translate }}
                </mat-label>
                <input [id]="'input_profile-change-email_Email'" matInput disabled [(ngModel)]="emailAtual" />
            </mat-form-field>

            <form [formGroup]="formGroup">
                <mat-form-field>
                    <mat-label>
                        {{ "CHANGE_EMAIL.INPUTS.NEW_EMAIL" | translate }}
                    </mat-label>
                    <input
                        [id]="'input_profile-change-email_NewEmail'"
                        matInput
                        #novoEmail
                        placeholder="{{ 'CHANGE_EMAIL.INPUTS.NEW_EMAIL_PLACEHOLDER' | translate }}"
                        maxlength="50"
                        formControlName="novoEmail"
                        required
                        email
                    />
                    <mat-hint align="end"> {{ novoEmail.value.length }} / 50 </mat-hint>
                    <mat-error>{{ "CHANGE_EMAIL.INPUTS.NEW_EMAIL_ERROR" | translate }}</mat-error>
                </mat-form-field>
            </form>
        </div>
    </mat-card-content>
</mat-card>
